<template>
  <div class="panel-in-tab">
    <search-box class="search-box">
      <el-form :inline="true" size="mini" label-width="110px" :model="searchForm" :rules="rules" ref="searchForm">
        <el-form-item label="商品编码" prop="skuCode">
          <el-input v-model.trim="searchForm.skuCode" placeholder="请输入" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="商品名称" prop="goodsName">
          <el-input v-model.trim="searchForm.goodsName" placeholder="请输入" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="SPU编码" prop="spuCode">
          <el-input v-model.trim="searchForm.spuCode" placeholder="请输入" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="上市清单名称" prop="name">
          <el-input v-model.trim="searchForm.name" placeholder="请输入" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="上架标识" prop="upTypes">
          <el-select v-model="searchForm.upTypes" multiple collapse-tags placeholder="全部" clearable>
            <el-option label="需上架" value="1"></el-option>
            <el-option label="同以前" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="SKU推广名称" prop="skuName">
          <el-input v-model.trim="searchForm.skuName" placeholder="请输入" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="发货周期" prop="sendCycle">
          <el-select v-model="searchForm.sendCycle" placeholder="请选择" multiple collapse-tags filterable size="mini">
            <el-option v-for="item in sendCycleList" :key="item.confValue" :label="item.confName" :value="item.confValue"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="变更状态" prop="updateState">
          <el-select v-model="searchForm.updateState" clearable @change="onSearch">
            <el-option label="变更" value="1"></el-option>
            <el-option label="未变更" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="变更时间">
          <form-date-range :form="searchForm" startKey="updateDateStart" :usingTime="false" endKey="updateDateEnd" valueFormat="yyyy-MM-dd"> </form-date-range>
        </el-form-item>
        <el-form-item label="清单发布时间">
          <form-date-range :form="searchForm" startKey="realPublishDateStart" :usingTime="false" endKey="realPublishDateEnd" valueFormat="yyyy-MM-dd"> </form-date-range>
        </el-form-item>
      </el-form>
      <template v-slot:right>
        <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
        <el-button class="orange-btn" size="mini" @click="onReset">重置</el-button>
      </template>
    </search-box>
    <el-row class="tabs-row">
      <el-col :span="10">
        <el-tabs v-model="activeTab" @tab-click="handleTabClick" class="tabs">
          <template v-if="storeTabs.length">
            <el-tab-pane
              v-for="(tab, index) in storeTabs"
              :key="index"
              :label="tab.label + ' ' + tab.count"
              :name="tab.name"
              :disabled="loading && tab.name != activeTab"
            ></el-tab-pane>
          </template>
          <div v-else class="occupy"></div>
        </el-tabs>
      </el-col>
      <el-col :span="14" class="table-btn-area">
        <el-button type="primary" size="mini" @click="tableVisible = true">表格设置</el-button>
        <el-button type="primary" size="mini" @click="batchListing(null)">批量上架</el-button>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </el-col>
    </el-row>
    <table-panel ref="tablePanel">
      <vxe-table
        stripe
        border
        ref="tableRef"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        :cell-style="cellStyle"
        v-if="tableReload"
        v-loading="loading"
        @checkbox-change="handleSelectionChange"
        @checkbox-all="handleSelectionChange"
      >
        <vxe-column type="checkbox" width="39" fixed="left"></vxe-column>
        <vxe-column v-for="(item, index) in columnList" :key="index" :field="item.prop" :title="item.label" :min-width="item.width" :fixed="item.fixed" show-overflow>
          <template #default="{ row, column }">
            <template v-if="item.label === '图片'">
              <el-button v-if="row.imgUrlList && row.imgUrlList.length" size="mini" type="text" @click="viewImg(row.imgUrlList)"
                >查看</el-button
              >
            </template>
            <template v-else-if="isShowTips(row, column)">
              <span>{{ row[item.prop] }}</span>
              <el-tooltip class="item" effect="dark" :content="getTips(row, column)" placement="top-start">
                <el-tag type="danger" effect="dark" size="mini" class="tagAlign">变</el-tag>
              </el-tooltip>
            </template>
            <template v-else-if="item.prop === 'name'">
              <span class="text-btn" @click="goListingList(row)">{{ row.name }}</span>
            </template>
            <span v-else>{{ row[item.prop] }}</span>
          </template>
        </vxe-column>
        <vxe-column title="操作" fixed="right" align="center" width="80">
          <template #default="{ row }">
            <el-button type="text" @click="batchListing(row)">上架</el-button>
          </template>
        </vxe-column>
      </vxe-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[100, 200, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
    <custom-table v-model="tableVisible" :tableDataSet="tableDataSet" v-if="tableVisible" @closeAddForm="closeAddForm" @confirm="confirm"></custom-table>
    <!-- 查看图片弹窗 -->
    <el-dialog title="图片查看" :visible.sync="imgFormVisible" :close-on-click-modal="false" width="50%" v-esc-close><imgShow :imgList="imgList"></imgShow></el-dialog>
  </div>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin';
import customPropsMixin from "../customProps.mixin";
import moment from 'moment';
import imgShow from "@/views/components/imgShow";
import axios from '@/utils/axiosInstance';
export default {
  name: 'PendingListing',
  mixins: [tableMixin, pagePathMixin, customPropsMixin],
  components: { imgShow },
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 100,
        total: 0,
      },
      tableReload: true,
      imgFormVisible: false,
      searchFormData: [],
      rules: {},
      selectedRows: [],
      imgList: [],
      rowData: {},
      searchForm: {
        productCode: '',
        spuCode: '',
        listingName: '',
        listingStatus: '',
        skuName: '',
        goodsName: '',
        sendCycle: [],
        updateState: '',
        updateDateStart: '',
        updateDateEnd: '',
        realPublishDateStart: '',
        realPublishDateEnd: ''
      },
      activeTab: '',
      storeTabs: [],
      sendCycleList: [],
      reportName: 'notNeedUp',
    };
  },
  computed: {},
  mounted() {
    this.getSendCycleList();
  },
  methods: {
    getStroeTab() {
      this.loading = true;
      const data = new FormData();
      data.append('state', 2);
      this.$q.newProduct.statisticsByStore({ data: data }).then((res) => {
        this.storeTabs = res.data.map((v) => ({
          label: v.storeName,
          name: v.storeCode,
          count: v.qty,
        }));
        if(!this.storeTabs || !this.storeTabs.length) {
          this.loading = false
          this.tableData.total = 0
          this.tableData.list = []
          return
        }
        let tabs = this.storeTabs.map((v) => v.name);
        this.activeTab = this.activeTab == 0 || !tabs.includes(this.activeTab) ? this.storeTabs[0].name : this.activeTab;
        this.$nextTick(_ => {
          this.onSearch();
        })
      });
    },
    handleTabClick(tab) {
      this.onSearch();
    },

    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },

    async init() {
      this.loading = true;
      let { skuCode, spuCode } = this.searchForm;
      let data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: {
          ...this.searchForm,
          storeCode: this.activeTab,
          state: 2,
          skuCode: skuCode ? skuCode.split(' ') : [],
          spuCode: spuCode ? spuCode.split(' ') : [],
        },
      };
      this.searchFormData = data;
      this.$q.newProduct
        .productListUpPage({ data: data })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            this.computeSpanData(res.data.list)
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },

    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },

    onReset() {
      this.searchForm = {
        productCode: '',
        spuCode: '',
        listingName: '',
        listingStatus: '',
        realPublishDateStart: '',
        realPublishDateEnd: '',
      };
      this.tableData.pageNum = 1;
      this.onSearch();
    },

    handleSelectionChange(selection) {
      this.selectedRows = selection.records || selection;
    },

    goListingList(row) {
      this.$router.push({ path: '/newProduct/listingList', query: { name: row.name } });
    },

    // 批量上架
    batchListing(row) {
      if (this.selectedRows.length === 0 && !row) {
        this.$message.warning('请先选择商品');
        return;
      }
      const stroeName = this.storeTabs.find((item) => item.name === this.activeTab).label;
      this.$confirm(`确认该商品在"${stroeName}"已上架吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          // 调用批量上架接口
          const ids = row ? [row.id] : this.selectedRows.map((item) => item.id);
          this.$q.newProduct.productListUpNew({ data: ids }).then((res) => {
            if (res.success) {
              this.$message.success('批量上架成功');
              this.$emit('getNumber');
              this.getStroeTab();
            }
          });
        })
        .catch(() => {});
    },

    // 查看图片
    viewImg(imgList) {
      this.imgFormVisible = true;
      let pathList = imgList ? imgList.map((v) => v.path) : [];
      this.imgList = pathList
    },

    isShowTips(row, column) {
      let propList = row.fieldBOS ? row.fieldBOS.map((v) => v.field) : [];
      return propList.includes(column.property);
    },
    getTips(row, column) {
      if (!row.fieldBOS) return;
      let propData = row.fieldBOS.find((v) => v.field == column.property);
      return `变更前：${propData.oldVal},变更后：${propData.newVal}`;
    },

    getSendCycleList() {
      let data = {
        pageSize: 999999,
        pageNum: 1,
        reportCode: '',
        hasCount: 'N',
      };
      data.reportCode = 'sendCycle';
      axios.post(`/ec-pc-api/custom/reports/data/sendCycle`, data).then((res) => {
        if (res.code == 200) {
          this.sendCycleList = res.data.list.filter((v) => v.categoryCode == 'sendCycle');
        }
      });
    },

    // 导出
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      this.searchFormData.pageSize = 9999999
      this.$q.newProduct
        .productListUpExport({
          data: this.searchFormData,
          options: { responseType: 'blob' },
        }).then((res) => {
        let fileName = '无需上架' + moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
        this.blobDownload(res, `${fileName}.xlsx`);
        loading.close();
      });
    },
    cellStyle({ row, column }) {
      if (row.fieldBOS && row.fieldBOS.length) {
        return {
          color: '#F56C6C',
        };
      }
      return {};
    },
  },
};
</script>

<style lang="stylus" scoped>
.panel-in-tab {
  >>> .search-outer>div {
    padding: 0;
  }
}

.search-box {
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input {
    width: 240px !important;
  }
}

>>> .date-range .single-date {
  width: 110px !important;
}

>>> .form-number-input .el-input-number {
  width: 105px !important;
}

>>> .form-number-input .el-input-number .el-input {
  width: 105px !important;
}

.tabs-row {
  margin-bottom: 5px;
}

.tabs {
  >>> .el-tabs__header {
    margin: 0 !important;
  }
}

.occupy {
  width: 200px;
  height: 20px
}

.table-btn-area {
  text-align: right;
  line-height: 40px;
}
.tagAlign {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
}

.text-btn {
  cursor: pointer;
  color: #0bb78e
}
</style>
